import React from 'react';
import Fragment from 'react-dot-fragment';
import BannerLayout from "../../../layouts/banner";

import Image from '../../../../../containers/assets/pf7.png';

const MarketShareStep17 = () => (
  <BannerLayout
    section="FEEDBACK"
    subSection="MARKET SHARE"
    hideAlert={true}
    subTitle="Research &amp; Investigate"
    paragraph2={(
      <Fragment>
        To better understand the attractiveness of your marketing mix,
        in relation to your competitors', we highly recommend you conduct
        Research and review the Team Reports, particularly the Marketing
        Analysis section. It has relative performance data such as product's
        ranking, selling prices, and awareness.
      </Fragment>
    )}
    visual={(
      <img src={Image} alt="preview" />
    )}
    visualProps={{
      noBorder: true,
      noBackground: true,
    }}
  />
);

export default MarketShareStep17;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/feedback/market-share/step17.js